var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7152 37.8147L53.3401 25.7297H50.8223L41.5967 36.2229L34.2283 25.7297H25.7297L36.8722 41.5973L25.7297 54.2703H28.2476L37.99 43.1891L45.7716 54.2703H54.2702L42.7146 37.8147H42.7152ZM39.2666 41.7371L38.1376 40.1571L29.1548 27.5844H33.0222L40.2714 37.7309L41.4004 39.311L50.8235 52.4999H46.9562L39.2666 41.7377V41.7371Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.bfc77d92bdd9d5e5735ced25abdab09d.svg";
export { ForwardRef as ReactComponent };